import AnalyticsTab from "./AnalyticsTab";

export default AnalyticsTab;